// extracted by mini-css-extract-plugin
export var copyableField = "_p9-4";
export var customerBadge = "_p9-0";
export var customerInfoTitle = "_p9-2";
export var details = "_p9-1";
export var dropdownContainer = "_p9-5";
export var dropdownImage = "_p9-6";
export var editAssigneeForm = "_p9-a";
export var editButton = "_p9-3";
export var email = "_p9-7";
export var hidden = "_p9-d";
export var input = "_p9-8";
export var saveButton = "_p9-b";
export var shopifyIcon = "_p9-c";
export var suggestionBadge = "_p9-e";
export var suggestionText = "_p9-f";
export var username = "_p9-9";